import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { SupplierNameMappingsApi } from "apis/SupplierNameMappingsApi";
import { SupplierNameMappingsSearchFilterQuery } from "models/filters/supplierNameMappings/SupplierNameMappingsSearchFilterQuery";
import { SupplierNameMapping } from "models/dbModels/supplierNameMappings/SupplierNameMapping";

export const getSupplierNameMappings = createAsyncThunk("supplierNameMappingSlice/getSupplierNameMappings", async () => {
    const response = await SupplierNameMappingsApi.Search({});
    return response.data;
});

export const getSupplierNameMappingDetails = createAsyncThunk("supplierNameMappingSlice/getSupplierNameMappingDetails", async (supplierId: number) => {
    const response = await SupplierNameMappingsApi.Search({ ids: [supplierId] });
    return response.data;
});

export const deleteSupplierNameMapping = createAsyncThunk("supplierNameMappingSlice/deleteSupplierNameMapping", async (params: SupplierNameMappingsSearchFilterQuery) => {
    const response = await SupplierNameMappingsApi.Delete(params);
    return response.data;
});

export const createSupplierNameMapping = createAsyncThunk("supplierNameMappingSlice/createSupplierNameMapping", async (supplierNameMapping: SupplierNameMapping) => {
    const response = await SupplierNameMappingsApi.Add([supplierNameMapping]);
    return response.data;
});

type InitialStateType = {
    id: number;
    supplierId: number;
    name: string;
    number: string;
    locked: boolean;
    loading: boolean;
    loadStocks: boolean;
    selectedRows: any[];
    selectedStockRows: any[];
    error: string;
    table: SupplierNameMapping[];
    showPopup: boolean;
};

const initialState: InitialStateType = {
    id: 0,
    supplierId: 0,
    name: "",
    number: "",
    locked: false,
    loading: false,
    loadStocks: false,
    selectedRows: [],
    selectedStockRows: [],
    error: "",
    table: [],
    showPopup: false,
};

const supplierNameMappingSlice = createSlice({
    name: "supplierNameMappingSlice",
    initialState: {
        ...initialState,
    },
    reducers: {
        updateSupplierNameMappingField: (state, action) => {
            return {
                ...state,
                [action.payload.key]: action.payload.value,
            };
        },
        cleanSupplierNameMappingDetails: (state) => {
            return {
                ...state,
                ...initialState,
            }
        },
    },
    extraReducers(builder) {
        builder.addCase(getSupplierNameMappings.pending, (state, action) => {
            state.loading = true;
            state.table = [];
            state.error = "";
        });
        builder.addCase(getSupplierNameMappings.fulfilled, (state, action) => {
            state.table = action.payload.data ? action.payload.data : [];
            state.loading = false;
        });
        builder.addCase(getSupplierNameMappings.rejected, (state, action) => {
            state.loading = false;
            state.table = [];
            // @ts-ignore
            state.error = action.payload.error || "";
        });

        builder.addCase(getSupplierNameMappingDetails.pending, (state, action) => {
            state.loading = true;
            state.table = [];
            state.error = "";
        });
        builder.addCase(getSupplierNameMappingDetails.fulfilled, (state, action) => {
            state.table = action.payload.data ? action.payload.data : [];
            state.loading = false;
        });
        builder.addCase(getSupplierNameMappingDetails.rejected, (state, action) => {
            state.loading = false;
            state.table = [];
            // @ts-ignore
            state.error = action.payload.error || "";
        });
    }
});

export const { updateSupplierNameMappingField, cleanSupplierNameMappingDetails } = supplierNameMappingSlice.actions;

export default supplierNameMappingSlice.reducer;